import React from 'react'

import { Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import ContextBasedRouter from 'Pods/Shared/ContextBasedRouter'
import i18n from 'Pods/Shared/I18n' // attempt to fix ssr text values
import PageLayout from 'Pods/Layout/PageLayout'

import ProfilePageContent from './ProfilePageContent'

function ProfilePage(props) {
  const {
    layout: {
      newRoyaltyUi,
      userInfo,
      totals,
      visitorActions,
      messagingForbidden,
      viewerIsAdmin,
    },
    navigation,
    footer,
    navClass,
    navContainerClass,
    navId,
  } = props

  const { locale, currentPathname } = navigation
  const basePath = locale === 'en' ? '/:username/:section?' : '/:locale/:username/:section?'

  return (
    <ContextBasedRouter initialPathname={currentPathname}>
      <Routes>
        <Route
          path={basePath}
          element={(
            <PageLayout
              component={ProfilePageContent}
              navigation={navigation}
              footer={footer}
              navClass={navClass}
              navContainerClass={navContainerClass}
              navId={navId}
              userInfo={userInfo}
              userTotals={totals}
              visitorActions={visitorActions}
              messagingForbidden={messagingForbidden}
              newRoyaltyUi={newRoyaltyUi}
              viewerIsAdmin={viewerIsAdmin}
            />
          )}
        />
      </Routes>
    </ContextBasedRouter>
  )
}

ProfilePage.propTypes = {
  navigation: PropTypes.object.isRequired,
  navClass: PropTypes.string.isRequired,
  navContainerClass: PropTypes.string.isRequired,
  navId: PropTypes.string.isRequired,
  layout: PropTypes.object.isRequired,
  footer: PropTypes.object.isRequired,
}

export default ProfilePage
